import { type GetApplicationVersionsRes } from './types';
import { Get } from '../index';

const BASE_URL = '/application-versions';

export const application = {
	getApplicationVersions: async <T = GetApplicationVersionsRes>(): Promise<T> => (await Get<T>(BASE_URL)).data,
	getPublicApplicationVersions: async <T = GetApplicationVersionsRes>(type: string): Promise<T> =>
		(await Get<T>(`/admin${BASE_URL}/public`, { params: { type } })).data,
};
